module.exports = __webpack_public_path__ + "static/media/subscribeDiscount3.e63dc3c9.svg";